export default __webpack_public_path__ + "static/media/expocebu-3.863c80bd.jpg";